export enum MessageType {
  primary = 'primary',
  secondary = 'secondary',
  success = 'success',
  danger = 'danger',
  warning = 'warning',
  info = 'info',
  none = 'none'
}

export declare interface Message {
  message: string;
  type: MessageType;
}

export declare interface GlobalMessageState {
  messages?: { [key: string]: Message };
}
